import moment from 'moment'
import * as React from 'react'

import Rating from 'main/components/school/Rating'
import { Small, Text } from 'main/ui'
import { SchoolPage_school_reviews } from '../../gql'
import { HeadingContainer } from './Review.styles'

interface IProps {
  review: SchoolPage_school_reviews
}

export default function Review(props: IProps) {
  const {
    review: { message, rating, submittedAt },
  } = props

  return (
    <div>
      <HeadingContainer>
        <Rating value={rating} withLabel />
        <Small muted>{moment(submittedAt).format('MMM D, YYYY')}</Small>
      </HeadingContainer>
      <div>
        <Text muted>{message}</Text>
      </div>
    </div>
  )
}
